import React, {FC} from "react";
import {Card, CardContent, CardProps, lighten, Typography, useTheme} from "@material-ui/core";
import {format} from "date-fns";
import {de} from "date-fns/locale";
import {ServiceChips} from "../../features/services/components/ServiceChip";
import {OrderAddress} from "../../features/orders/redux/types";
import {getFullName} from "../../utils";
import {Event, Schedule} from "@material-ui/icons";

interface SummaryStepProps {
    isDesktop: boolean;
    onSubmit: () => void;
    clientEmail: string;
    workerName: string;
    servicesIds: string[];
    timeRange: { estimatedFrom: number; estimatedTo: number };
    serviceAddress: OrderAddress;
    invoiceAddress?: OrderAddress;
}

export const OrderAddressCard: FC<{ label: string; orderAddress: OrderAddress, email?: string, cardProps?: CardProps }> = (props) => {
    return (
        <Card {...props.cardProps}>
            <CardContent>
                <Typography color="textSecondary" style={{marginBottom: 8}}>{props.label}</Typography>
                <Typography
                    variant="body2"
                    style={{marginBottom: 8}}>
                    {props.orderAddress.address.formattedAddress}
                </Typography>
                <Typography
                    variant="body2">{getFullName(props.orderAddress.name)}</Typography>
                {props.email && <Typography variant="body2">{props.email}</Typography>}
                <Typography variant="body2">{props.orderAddress.phone}</Typography>
            </CardContent>
        </Card>
    );
}

export const SummaryStep: FC<SummaryStepProps> = (props) => {
    const theme = useTheme();
    return (
        <React.Fragment>
            <Typography color={"textSecondary"} style={{marginTop: 16, marginBottom: 16}}>
                Falls etwas nicht stimmt klicken Sie auf zurück um zu korrigieren.
            </Typography>
            <Typography color="primary">Ihr Termin:</Typography>
            {!props.isDesktop && <Typography variant="h5" color="primary" style={{marginBottom: 8}}>Fast geschafft!<br/>Nur noch dieser Schritt.</Typography>}
            <div style={{width: "100%", display: props.isDesktop ? "flex" : undefined}}>
                <Card variant="outlined" style={{
                    backgroundColor: lighten(theme.palette.primary.main, 0.95),
                    width: props.isDesktop ? "50%" : undefined
                }}>
                    <CardContent>
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <Typography color="textSecondary" variant={"h5"}
                                        style={{display: "inline-flex", alignItems: "center"}}>
                                <Event fontSize="inherit"
                                       color="inherit"
                                       style={{marginRight: 4}}/>{format(props.timeRange.estimatedFrom, "EEEE, dd.MM.yyyy", {locale: de})}
                            </Typography>
                            <Typography color={"textSecondary"}
                                        style={{marginBottom: 8, display: "inline-flex", alignItems: "center"}}>
                                <Schedule fontSize="inherit"
                                          color="inherit" style={{
                                    marginRight: 7,
                                    marginLeft: 5
                                }}/>{format(props.timeRange.estimatedFrom, "HH:mm")}{" - "}{format(props.timeRange.estimatedTo, "HH:mm")}
                            </Typography>
                        </div>
                        <ServiceChips size={"medium"} serviceIds={props.servicesIds}/>
                        <Typography variant="body2" color="textSecondary"
                                    style={{marginTop: 8, paddingLeft: 16}}>Helfer: {props.workerName}</Typography>
                        <div style={{display: "flex", marginTop: 8, flexDirection: props.isDesktop ? "row" : "column"}}>
                            <OrderAddressCard
                                cardProps={{style: {width: "100%", marginRight: 16}}}
                                label={"Einsatzort"}
                                orderAddress={props.serviceAddress}
                                email={props.clientEmail}
                            />
                            {props.invoiceAddress &&
                            <OrderAddressCard
                                cardProps={{style: {width: "100%", marginTop: props.isDesktop ? undefined : 8}}}
                                label="Rechnungsadresse"
                                orderAddress={props.invoiceAddress}
                            />}
                        </div>
                    </CardContent>
                </Card>
                {props.isDesktop &&
                <div style={{display: "flex", alignItems: "center", justifyContent: "center", width: "50%"}}>
                    <Typography variant="h5" color="primary">Fast geschafft!<br/>Nurnoch dieser Schritt.</Typography>
                </div>}
            </div>
        </React.Fragment>
    )
};
